import ImageIcon from '@mui/icons-material/Image';
import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';

const imgSize = '104px';
const iconSize = '64px';

export const BoxStyled = styled(Box)({
  display: 'flex',
  width: imgSize,
  height: imgSize,
  backgroundColor: 'rgba(0, 0, 0, .04)',
});

export const ImgStyled = styled('img')({ width: imgSize, height: imgSize, objectFit: 'contain' });

export const ImageIconStyled = styled(ImageIcon)({
  width: iconSize,
  height: iconSize,
  margin: 'auto',
});
